module.exports = __webpack_public_path__ + "static/media/LJP.427356f0.pdf";